
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/we-corporate-social-responsibility",
      function () {
        return require("private-next-pages/about-us/we-corporate-social-responsibility/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/we-corporate-social-responsibility"])
      });
    }
  